module.exports = __webpack_public_path__ + "img/tips7.7f38bacc.png";